import { hexToRgb, isBrightRGB } from "@ponder-shared/utils/colorInfo";
import { environment } from "../../../../environments/environment";

export function styleDeckElementBackground(outerElement: HTMLElement, innerElement: HTMLElement, color: string, backgroundId: string | undefined): void {
    styleDeckElementBackgroundInternal(outerElement, innerElement, color, backgroundId, false);
}

export function styleDeckElementBackgroundSmall(outerElement: HTMLElement, innerElement: HTMLElement, color: string, backgroundId: string | undefined): void {
    styleDeckElementBackgroundInternal(outerElement, innerElement, color, backgroundId, true);

}

function styleDeckElementBackgroundInternal(outerElement: HTMLElement, innerElement: HTMLElement, color: string, backgroundId: string | undefined, smallDiv: boolean): void {
        const bgRGB = hexToRgb(color);

        outerElement.style.setProperty("background-color", `rgb=(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]})`);
    
        if (backgroundId) {
            outerElement.style.setProperty("background", `url(${environment.ponderImageBaseUrl}/card/art/front/${backgroundId}.jpg)`);
            outerElement.style.setProperty("background-position", "-2% 15%");

            if (!smallDiv) {
                outerElement.style.setProperty("background-size", "50%");
                innerElement.style.setProperty("background", `linear-gradient(to right, rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 0.45), rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 0.99), rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 1.0))`);
            } else {
                outerElement.style.setProperty("background-size", "75%");
                innerElement.style.setProperty("background", `linear-gradient(to right, rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 0.45), rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 0.65), rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 0.99), rgba(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}, 1.0))`);
            }
        } else {
            innerElement.style.setProperty("background", `linear-gradient(to right, rgb(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]}), rgb(${bgRGB[0]}, ${bgRGB[1]}, ${bgRGB[2]})`);
        }
    
        // disabling this part for now. generally it works, but think better long-term is to let the user choose a color.
        // until then, defaulting to white to better support hover effects.
        //const textColor = isBrightRGB(bgRGB[0], bgRGB[1], bgRGB[2]) ? "#000000" : "#FFFFFF";
        //outerElement.style.setProperty("color", textColor);
        //outerElement.style.setProperty("stroke", textColor);
}